export default __webpack_public_path__ + "static/media/customer.80ef8021.png";